const MIN_FILE_SIZE = 250 * 1024;

export const generateThumbnail = (
  file: File,
  maxSize = 250 * 1024, // 250KB
  minQuality = 0.00001,
  initialQuality = 0.9,
  qualityStep = 0.005
): Promise<Blob> => {
  if (file.size < maxSize) {
    return Promise.resolve(file);
  }

  // Calculate quality using the adjusted formula for up to 20MB
  const fileSizeInKB = file.size / 1024;
  let quality = 0.8 - 0.000035 * (fileSizeInKB - 250);
  // Clamp quality between minQuality and initialQuality
  if (quality < minQuality) quality = minQuality;
  if (quality > initialQuality) quality = initialQuality;

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    const img = new Image();

    reader.onload = (e) => {
      img.src = e.target?.result as string;
    };

    img.onload = async () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      if (!ctx) return reject("Canvas not supported");

      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      // Compress only once at calculated quality
      canvas.toBlob(
        (blob) => {
          if (!blob) return reject("Thumbnail generation failed");
          resolve(blob);
        },
        "image/jpeg",
        quality
      );
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
